import escapeRegExp from 'lodash/escapeRegExp'
import escapeHtml from 'escape-html'

export default (value, search) => {
  if (value == null || value === '') {
    return value
  }

  if (search == null || search === '') {
    return escapeHtml(value)
  }

  const regex = new RegExp(escapeRegExp(search), 'gi')

  return String(escapeHtml(value)).replace(regex, match => {
    return '<span class="text--highlight">' + match + '</span>'
  })
}
